function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.32118 9.26017L5.67743 7.63757C5.48091 7.44358 5.16433 7.44563 4.97034 7.64215C4.77634 7.83867 4.77839 8.15525 4.97492 8.34924L7.00768 10.3558C7.21669 10.5622 7.55768 10.5448 7.7446 10.3182L11.0452 6.31824C11.2209 6.10524 11.1907 5.7901 10.9777 5.61435C10.7647 5.4386 10.4496 5.4688 10.2738 5.68179L7.32118 9.26017Z",
  fill: "#92929D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.3335 0.833374H9.66683C12.7044 0.833374 15.1668 3.29581 15.1668 6.33337V9.66671C15.1668 12.7043 12.7044 15.1667 9.66683 15.1667H6.3335C3.29593 15.1667 0.833496 12.7043 0.833496 9.66671V6.33337C0.833496 3.29581 3.29593 0.833374 6.3335 0.833374ZM6.3335 1.83337C3.84821 1.83337 1.8335 3.84809 1.8335 6.33337V9.66671C1.8335 12.152 3.84821 14.1667 6.3335 14.1667H9.66683C12.1521 14.1667 14.1668 12.152 14.1668 9.66671V6.33337C14.1668 3.84809 12.1521 1.83337 9.66683 1.83337H6.3335Z",
  fill: "#92929D"
});

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.26a328fd.svg";
export { ForwardRef as ReactComponent };